import React from "react";
import { ReactComponent as HeartIcon } from "../../../../Assets/Icons/heartIcon.svg";
import { ReactComponent as LocationIcon } from "../../../../Assets/Icons/locationPopupIcon.svg";
import { ReactComponent as BikeIcon } from "../../../../Assets/Icons/bikesvg.svg";
import { ReactComponent as InStoreIcon } from "../../../../Assets/Icons/instoresvg.svg";

const OfferCard = ({ img, title, description, discount, location, distance }) => {

  const truncateTitle = (title) => {
    return title?.length > 20 ? `${title.substring(0, 20)}...` : title;
  };

  return (
    <div className="min-h-[180px] w-[280px] bg-white flex flex-col justify-start items-center rounded-[8px] drop-shadow-md">
      <div className="relative w-full h-[110px]">
        <img src={img} className="w-full h-full rounded-tl-[8px] rounded-tr-[8px] object-cover"/>
        <div className="absolute top-2 right-2 bg-white rounded-full p-1 shadow">
          <HeartIcon />
        </div>
      </div>
      <div className="p-3 w-full">
        <div className="w-full flex justify-between items-center">
          <p className="text-[#303030] font-poppins font-[500] text-[12px] w-[70%]">
            {truncateTitle(title)}
          </p>
        </div>
        {/* Location and distance row */}
        <div className="flex items-center gap-2 mt-2">
          <LocationIcon className="w-[14px] h-[14px] text-gray-400" style={{ color: '#8C8C8C', fill: '#8C8C8C' }} />
          <span className="text-[#8C8C8C] font-poppins font-[400] text-[10px] whitespace-nowrap overflow-hidden text-ellipsis max-w-[110px]">
            {location}
          </span>
        </div>
        <div className="flex items-center gap-1 mt-1">
          <BikeIcon className="w-[14px] h-[14px]" style={{ color: '#D1D5DB', fill: '#D1D5DB' }} />
          <span className="text-[#8C8C8C] font-poppins font-[400] text-[10px] whitespace-nowrap">
            {distance} km away
          </span>
        </div>
        {/* <p className="text-[#8C8C8C] font-poppins font-[400] text-[5px] whitespace-nowrap">
          {description}
        </p> */}
        <div className="mt-3">
          <div className="w-full border-t border-dashed border-gray-300 mb-2" style={{ borderTopWidth: '0.5px', borderStyle: 'dashed' }} />
          <div className="flex gap-2 mt-1">
            <div className="flex items-center bg-[#E6F7FF] rounded px-2 py-1">
              {/* Discount Icon */}
              <svg className="w-4 h-4 text-[#00ADEF] mr-1" fill="none" stroke="currentColor" strokeWidth="1.2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="#00ADEF" strokeWidth="1.2" fill="#E6F7FF" /><text x="12" y="16" textAnchor="middle" fontSize="10" fill="#00ADEF" fontWeight="bold">%</text></svg>
              <span className="text-[#00ADEF] font-poppins font-[600] text-[10px] whitespace-nowrap">{discount}</span>
            </div>
            <div className="flex items-center bg-[#E6F7FF] rounded px-2 py-1">
              {/* Store Icon */}
              <InStoreIcon className="w-3 h-3 text-[#00ADEF] mr-1" />
              <span className="text-[#00ADEF] font-poppins font-[600] text-[10px] lg:text-[10px] whitespace-nowrap">In Store</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
